export const colorVars = {
  gray: "rgba(244, 243, 242, 1)",
  gray2: "rgba(194, 194, 194, 1)",
  textPrimary: "rgba(51, 51, 51, 1)",
  textSecondary: "rgba(73, 73, 73, 1)",
  bluePrimary: "rgba(0, 102, 204, 1)",
  blueSecondary: "rgba(6, 86, 166, 1)",
  pink: "rgba(235, 74, 122, 1)",
  yellow: "rgba(253, 208, 23, 1)",
  error: "red",
  white: "rgba(244, 243, 242, 1)",
};
